<script setup>
import IndexationSitemapForm from '@frontJs/components/forms/projectManagement/seo/IndexationSitemapForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, websiteVariants, seoIndexationSitemap } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    websiteVariants: {
        type: Array,
        required: false,
    },
    seoIndexationSitemap: {
        type: [Object, null],
        required: false,
        default: null,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="seoIndexationSitemap">
            Mettre à jour le sitemap d'indexation #{{ seoIndexationSitemap.id }}
            - SEO/GEO - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un sitemap d'indexation - SEO/GEO - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle v-if="seoIndexationSitemap" :tenant-name="tenant.name">
        Gestion de projet - SEO/GEO - Mettre à jour le sitemap d'indexation #{{
            seoIndexationSitemap.id
        }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - SEO/GEO - Créer un sitemap d'indexation
    </PageTitle>

    <IndexationSitemapForm
        :tenant="tenant"
        :website-variants="websiteVariants"
        :seo-indexation-sitemap="seoIndexationSitemap"
    />
</template>
